import { Injectable, EventEmitter } from '@angular/core';


@Injectable()
export class TourNavigationService {

  tourStep: number;
  public Navigator: EventEmitter<number> = new EventEmitter<number>();
  // public StepForChangeStyle: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public changeTourStep(value): void {
    if (value) {
      this.tourStep = value;
    }
    this.Navigator.emit(this.tourStep);
  }
  // public setTourStep(value): void {
  //   this.StepForChangeStyle.next(value);
  // };

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/app/services/tour-navigation.service.ts